<template>
	<div class="menu-content" v-if="ui.show">
		<v-container>
			<v-row>
				<v-col cols="12" class="pt-0 pb-5 d-flex align-center">
					<v-btn
						small
						fab
						class="mr-2 elevation-3"
						color="primary"
						@click="back()"
					>
						<v-icon>
							mdi-arrow-left
						</v-icon>
					</v-btn>

					<div class="breadcrumbs">
						<div
							class="breadcrumbs-item"
							v-for="(category, key) in categories"
							@click="go(key + 1)"
						>
							{{ category.name }}
						</div>
					</div>
				</v-col>

				<template v-if="subcategories.length > 0">
					<v-col
						cols="2"
						v-for="(subcategory, key) in subcategories"
						@click="open(subcategory)"
					>
						<!-- <v-btn large block color="primary">
							<small>
								{{ subcategory.name }}
							</small>
						</v-btn> -->

						<v-img
							src="https://repositoriomdm.blob.core.windows.net/b2c/menu/productos/Producto/MenuMaderas_curva1.jpg"
							class="white--text align-end pb-1"
							gradient="to bottom, rgba(0,0,0,.05), rgba(0,0,0,.8)"
							height="60px"
						>
							<span
								class="pl-2"
								style="font-size: 10px; letter-spacing: 1.1px; font-weight: 50;"
							>
								{{ subcategory.name }}
							</span>
						</v-img>
					</v-col>
				</template>

				<template v-else>
					<v-col cols="12" class="d-flex justify-center flex-column">
						<h2 class="mb-2">
							{{ getLastCategory().name }}
						</h2>
						<p>
							Lorem ipsum dolor sit amet consectetur adipisicing
							elit. Repellat quidem quisquam facilis nisi animi
							architecto in earum iusto, accusamus odio et
							voluptatum. Neque aliquid facilis vero. Iusto
							nesciunt eveniet suscipit!
						</p>
					</v-col>
				</template>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/main";

export default {
	name: "Products",

	data() {
		return {
			categories: [],

			categoryActive: {},

			ui: {
				show: false,
			},
		};
	},

	created() {
		EventBus.$on("MenuToggle", (data) => {
			if (data.name === "products") {
				this.ui.show = !this.ui.show;
			}
		});

		this.get();
	},

	methods: {
		async get() {
			await this.$store.dispatch("getCategories");

			this.categories.push({
				name: "productos",
				categories: this.getParentCategories,
			});
		},

		open(category) {
			this.categories.push(category);

			if (category.categories) {
				if (category.categories.length) {
					return false;
				}
			}

			this.$router.replace({
				name: "Search",
				query: {
					categories: this.categories.map((category) => category.id),
				},
			});

			this.$store.dispatch("search", null);

			this.categoryActive = category;

			this.ui.show = false;
		},

		back() {
			if (this.categories.length > 1) {
				this.categories.splice(this.categories.splice.length - 1, 1000);
			}
		},

		go(key) {
			this.categories.splice(key, 1000);
		},

		getLastCategory() {
			if (this.categories.length > 1) {
				return this.categories[this.categories.length - 1];
			}

			return this.categories[0];
		},
	},

	computed: {
		...mapGetters({
			getParentCategories: "getParentCategories",
		}),

		subcategories() {
			let lastCategory = this.getLastCategory();

			if (lastCategory.categories) {
				return lastCategory.categories;
			} else {
				this.categories[this.categories.indexOf(lastCategory) - 1];
			}

			return [];
		},
	},
};
</script>

<style lang="css" scoped>
.menu-content {
	height: 100%;
	width: 100%;
	height: 250px;
	overflow-y: scroll;
	box-shadow: 0px 1px 26px 3px rgba(0, 0, 0, 0.3);
}

.breadcrumbs {
	display: flex;
}

.breadcrumbs-item {
	display: flex;
	align-items: center;
	position: relative;
	color: #0078d7;
	font-size: 0.8rem;
	cursor: pointer;
	padding: 0 15px;
	text-transform: uppercase;
	text-decoration: underline;
}

.breadcrumbs-item::after {
	content: "/";
	color: #aaa;
	right: 0;
	cursor: default;
	text-decoration: none;
	position: absolute;
}
</style>
